module.exports = __webpack_public_path__ + "img/3dmodel_white.1a9883f4.png";